import * as React from 'react';
import { Body2, Image, UIHeading5 } from '@cian/ui-kit';

import { INewbuildingSummaryCell } from '../../../../types/newbuildingsCompare';
import { NewbuildingFavoriteButton } from '../../../../containers/NewbuildingFavoriteButton';
import { NewbuildingDeleteButton } from '../../../../containers/NewbuildingDeleteButton';
import { NewbuildingCallToAction } from '../../../../containers/NewbuildingCallToAction';
import { NewbuildingChatButton } from '../../../../containers/NewbuildingChatButton';
import { Rating } from '../../../NewbuildingsComparePage/parts/Cell/cells/NewbuildingSummaryCell/parts/Rating';
import { Link } from '../../../Link';
import { PinButton } from '../PinButton';
import * as style from './style.css';

export interface INewbuildingCardProps {
  cell: INewbuildingSummaryCell;
  isPinned: boolean;
  onTogglePin: () => void;
}

export const NewbuildingCard: React.FC<INewbuildingCardProps> = ({ cell, isPinned, onTogglePin }) => {
  const { data, state } = cell;

  if (!data) {
    return <Body2>{state.text ?? ''}</Body2>;
  }

  const { id, name, fullUrl, imageUrl, isFavorite, priceRange, reviews, builders, sellers } = data;
  const hasChat = [...builders, ...sellers].some(contact => contact.chat?.enabled);

  return (
    <div className={style['container']}>
      <div className={style['photo']}>
        <Image alt={name} borderRadius="16px" height={132} objectFit="cover" src={imageUrl} width="100%" />
        <div className={style['pin']}>
          <PinButton active={isPinned} onClick={onTogglePin} />
        </div>
        <div className={style['actions']}>
          <NewbuildingDeleteButton newbuildingId={id} size="M" />
          <NewbuildingFavoriteButton gaLabel={fullUrl} isFavorite={isFavorite} newbuildingId={id} />
        </div>
      </div>
      <div className={style['info']}>
        <div className={style['name']}>
          <Link href={fullUrl} target="_blank">
            <UIHeading5 color="text-main-default">{name}</UIHeading5>
          </Link>
        </div>
        {priceRange && <UIHeading5>{priceRange}</UIHeading5>}
        <Rating countText={reviews.countText} rating={reviews.rating} />
        <div className={style['buttons']}>
          <NewbuildingCallToAction builders={builders} newbuildingId={id} sellers={sellers} url={fullUrl} />
          {hasChat && (
            <NewbuildingChatButton
              builders={builders}
              fullscreen
              newbuildingId={id}
              sellers={sellers}
              size="M"
              url={fullUrl}
            />
          )}
        </div>
      </div>
    </div>
  );
};
